import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToastService } from '../services/toast-service.service';

@Injectable()
export class ForbiddenInterceptor implements HttpInterceptor {
  constructor(private toastService: ToastService, private router: Router) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 403 && this.isOnboardingRequired(error)) {
          if (!this.router.url.startsWith('/onboarding-training')) {
            this.router.navigateByUrl('/onboarding-training');
          }
          return throwError(() => error);
        }
        if (error.status === 403) {
          this.toastService.showErrorMessage('You do not have permission for this action.');
        }
        return throwError(() => error);
      })
    );
  }

  private isOnboardingRequired(error: HttpErrorResponse): boolean {
    const body = error.error;
    if (!body) {
      return false;
    }
    if (typeof body === 'string') {
      return body.includes('ONBOARDING_REQUIRED');
    }
    return body.code === 'ONBOARDING_REQUIRED';
  }
}
